import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { toast } from "react-toastify"

export function useMarkLogsAsRead() {
  const request = useAxiosRequest()
  const markAsRead = async (imo: string) => {
    try {
      await request<any, any>({
        url: `${BASE_URL}/prevetting/logs/unread`,
        method: "POST",
        params: { imo },
      })
    } catch (err: unknown) {
      const message = "Unable to mark logs as read"
      console.error(message, err)
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    }
  }
  return { markAsRead }
}
